import { render, staticRenderFns } from "./MarketSecond.vue?vue&type=template&id=3d224e1b&scoped=true"
import script from "./MarketSecond.vue?vue&type=script&lang=js"
export * from "./MarketSecond.vue?vue&type=script&lang=js"
import style0 from "./MarketSecond.vue?vue&type=style&index=0&id=3d224e1b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d224e1b",
  null
  
)

export default component.exports